const zones = window.cartDrawer.zones
let currentTotalPrice = window.cartDrawer.totalPrice

const initNewPdpEvents = () => {
	document.addEventListener("click", e => {
		if (e.target.id === "mainPrdcontformbtn") {
			const id = e.target.closest("#mainPrd").querySelector("#variant_selectPrd").value
			if (!id) return
			if (id === 0 || id === "0") return
			console.log(id)

			addItem(Number(id))
			openCart(e)
		}
	})
}

const renderUpsell = async () => {
	const upsell = document.querySelector(".cartupselljs")
	if (window.cartDrawer?.enableRecommendations === false) {
		if (upsell) upsell.innerHTML = ''
		setTimeout(() => { init(); initCompleteTheFit(); loadCtfFallbacks().then(_trackUpsellImpression) }, 500)
		return
	}
	const firstItem = document.querySelector(".cart_drawer--item")
	const id = firstItem
		? firstItem.getAttribute("data-id")
		: window.cartDrawer.cart.item_count > 0
			? window.cartDrawer.cart.items[0].product_id
			: 7907606987011 + "&limit=6"
	const res = await fetch(
		`/recommendations/products?section_id=product-recommendations_cart&product_id=${id}`
	)
	const html = await res.text()
	if (upsell) upsell.innerHTML = html

	setTimeout(() => { init(); initCompleteTheFit(); loadCtfFallbacks().then(_trackUpsellImpression) }, 500)
}

const loadmoreCleanup = () => {
	const upsell = document.querySelector("[data-tab=upsell]")
	const upsell_prds = upsell.querySelectorAll(".cart_upsell-product")
	const upsellBtn = document.querySelector("[data-tab-loadmore=upsell]")
	const wishlist = document.querySelector("[data-tab=wishlist]")
	const wishlist_prds = wishlist.querySelectorAll(".cart_upsell-product")
	const wishlistBtn = document.querySelector("[data-tab-loadmore=wishlist]")
	const wishlistControl = document.querySelector("[data-tab-control=wishlist]")

	if (wishlistControl.classList.contains("selected")) {
		console.log(wishlist_prds)

		if (wishlist_prds.length < 5) {
			wishlistBtn.classList.add("hidden")
			wishlist.classList.remove("hidden")
			upsell.classList.add("hidden")
			upsellBtn.classList.add("hidden")
		} else {
			wishlistBtn.classList.remove("hidden")
			wishlist.classList.remove("hidden")
			upsell.classList.add("hidden")
			upsellBtn.classList.add("hidden")
		}
	} else {
		if (upsell_prds.length < 5) {
			upsellBtn.classList.add("hidden")
			wishlist.classList.add("hidden")
			upsell.classList.remove("hidden")
			wishlistBtn.classList.add("hidden")
		} else {
			upsellBtn.classList.remove("hidden")
			wishlist.classList.add("hidden")
			upsell.classList.remove("hidden")
			wishlistBtn.classList.add("hidden")
		}
	}
}

const openWishlistDrawer = e => {
	if (e) stopEvents(e)
	openCart()
	const tab = document.querySelector('[data-tab-control="wishlist"]')
	if (tab) tab.click()
	setTimeout(() => {
		const cartContainer = document.querySelector(".cart_container")
		if (cartContainer) cartContainer.scrollBy(0, cartContainer.clientHeight)
	}, 500)
}

const addEventPdpButton = () => {
	document.addEventListener("click", e => {
		if (e.target.classList.contains("add-to-cart-primary-btn")) {
			const parent = e.target.closest("#cart-form_ppr")
			if (parent && parent.querySelector("#product-select_ppr")) stopEvents(e)
			updateQuickAddText()
			const id = parent.querySelector("#product-select_ppr").value
			if (!id) return
			addItem(Number(id))
		}
	})
}

const hideItems = () => {
	const empty = document.querySelector(".cart_drawer--empty")
	if (empty) empty.classList.remove("hidden")
	const items = document.querySelector(".cart_drawer--items")
	if (items) items.classList.add("hidden")
}

const showItems = () => {
	const empty = document.querySelector(".cart_drawer--empty")
	if (empty) empty.classList.add("hidden")
	const items = document.querySelector(".cart_drawer--items")
	if (items) items.classList.remove("hidden")
}

const hideShippingBar = () => {
	document.querySelector(".cart-shipping_bar").classList.add("hidden")
}
const showShippingBar = () => {
	document.querySelector(".cart-shipping_bar").classList.remove("hidden")
}

const setShippingUpdating = flag => {
	const drawer = document.querySelector("#cart_drawer_reload")
	if (!drawer) return
	drawer.classList.toggle("cart_drawer--updating", flag)
}

const hideShippingTotal = () => {
	const row = document.querySelector(".cart-drawer-total__row")
	if (row) row.classList.add("hidden")
}

const showShippingTotal = () => {
	const row = document.querySelector(".cart-drawer-total__row")
	if (row) row.classList.remove("hidden")
}

const updateQuickAddText = () => {
	setTimeout(() => {
		const flag = sessionStorage.getItem("cart_change_id") !== null
		const title = document.querySelector(".prdsctcst__wrapper-top h4")
		const btn = document.querySelector(".prdsctcst .prdsctcst__cont-form-btn")
		if (title)
			title.innerText = flag ? window.cartDrawer.t.edit.title : window.cartDrawer.t.add.title
		if (btn) btn.innerText = flag ? window.cartDrawer.t.edit.btn : window.cartDrawer.t.add.btn
		if (btn && btn.classList.contains("outofstock")) btn.innerText = window.cartDrawer.t.outofstock
	}, 100)
}

const checkIfCartIsEmpty = count => {
	if (count === 0) {
		hideItems()
		hideShippingBar()
	} else {
		showItems()
		showShippingBar()
	}
}

const showWishlistPopup = () => {
	const wishlistPopup = document.querySelector(".cart_drawer-popup")
	if (wishlistPopup) wishlistPopup.classList.remove("hidden_pupup")
}

const closeWishlistPupup = () => {
	const wishlistPopup = document.querySelector(".cart_drawer-popup")
	if (wishlistPopup) wishlistPopup.classList.add("hidden_pupup")
}

const updateShipping = async () => {
	const uabCountry = sessionStorage.getItem("countryCode")
	const currentZone = zones.filter(zone => zone.country_code === uabCountry)

	if (currentZone.length > 0) {
		updagteShippingText(currentZone[0])
	} else {
		const defaultZone = zones.filter(zone => zone.country_code === "US")
		console.log("updateShipping", defaultZone)

		if (defaultZone.length > 0) updagteShippingText(defaultZone[0])
	}
	setShippingUpdating(false)
}

const formatShippingText = (template, amountText) => {
	if (!template) return ""
	const replaced = amountText ? template.replace("{{amount}}", amountText) : template
	return replaced.replace(/\n/g, "<br>")
}

const updagteShippingText = zone => {
	const textEL = document.querySelector(".cart-shipping_bar__text")

	const limit = Number(zone.free_shipping_standart) / 100
	const limit2 = Number(zone.free_shipping_express) / 100
	const total =
		Number(document.querySelector("[data-total-price]").getAttribute("data-total-price")) / 100

	const amount_left = parseInt(limit - total).toFixed(2)
	const amount_left_express = parseInt(limit2 - total).toFixed(2)
	const amount_text = `${window.cartDrawer.currencySymbol}${amount_left}`
	const amount_text_express = `${window.cartDrawer.currencySymbol}${amount_left_express}`
	const text_parsed = formatShippingText(window.cartDrawer.t.shipping.left, amount_text)
	const text_parsed_express = formatShippingText(
		window.cartDrawer.t.shipping.leftExpress,
		amount_text_express
	)

	if (total < limit) {
		hideShippingTotal()
		if (textEL) textEL.innerHTML = `<p>${text_parsed}</p>`
	} else {
		showShippingTotal()
		if (textEL) {
			textEL.innerHTML = window.cartDrawer.shippingFreeHtml
		}
		if (total < limit2 && total > limit && total !== limit2 && total !== limit) {
			if (textEL) textEL.innerHTML = `<p>${text_parsed_express}</p>`
		}

		document.querySelector(".cart_drawer--messege--shipping").classList.add("hidden")
	}
	const drawer = document.querySelector("#cart_drawer_reload")
	if (drawer) drawer.classList.toggle("cart_drawer--free-shipping", total >= limit)

	let progress = total * 100 / limit
	if (total >= limit) {
		progress = total * 100 / limit2
		if (document.querySelector(".cart_drawer--messege--shipping [cart-banner-text]"))
			document.querySelector(".cart_drawer--messege--shipping [cart-banner-text]").innerHTML =
				window.cartDrawer.t.shipping.congratsExpress
		if (total <= limit2)
			document.querySelector(".cart_drawer--messege--shipping [cart-banner-text]").innerHTML =
				window.cartDrawer.t.shipping.congrats
	}

	const boundedProgress = Math.max(0, Math.min(100, progress))
	document.documentElement.style.setProperty(
		"--cart-shipping-progress",
		`${boundedProgress}%`
	)
}

const loadProducts = items => {
	const products = items.map((item, idx) => items[items.length - 1 - idx])
	document.querySelector('[data-tab="wishlist"]').innerHTML = ""
	products.forEach((product, i) => {
		let newHtml = `
      <div class="cart_upsell-product">
        <div class="cart_upsell-product__overlay">
          <div class="cart_upsell-remove-from-wishlist" data-variant-id="${product.variant
						.id}" data-customer-id="${window.customerId}" data-id="${product.id}">
            ${window.cartDrawer.binIcon}
          </div>
          <a href="/products/${product.handle}" onClick="location.href = '/products/${product.handle}'">
            <img src="${product.featuredImage}" alt="${product.title}">
          </a>
        </div>
        <div class="cart_upsell-product__wrap">
          <div class="cart_upsell-product__title">
            <a href="/products/${product.handle}">${product.title}</a>
          </div>
          <div class="cart_upsell-product__price">
            ${window.cartDrawer.currencySymbol}${parseInt(
			product.variant.price * window.Shopify.currency.rate
		)}
          </div>
        </div>
      </div>
    `

		document.querySelector('[data-tab="wishlist"]').innerHTML += newHtml
	})
}

const getWishlist = async () => {
	const url = "https://api.myshopapps.com/wishlist/V1/fetchWishlistData/" + window.customerId
	const options = {
		method: "POST",
		headers: {
			xtoken: window.wishlistApiKey,
			"Content-Type": "application/x-www-form-urlencoded",
			Accept: "application/json"
		},
		body: new URLSearchParams({ category_id: "" })
	}

	try {
		const response = await fetch(url, options)
		const data = await response.json()
		if (data.result === undefined) return

		if (data.result.length > 0) {
			loadProducts(data.result)
			if (document.querySelector(".empty_block[data-upsell-grid]"))
				document.querySelector(".empty_block[data-upsell-grid]").classList.remove("empty_block")
			if (data.result.length <= 4) {
				if (document.querySelector('.cart_upsell-grid--show [data-tab-loadmore="wishlist"]'))
					document
						.querySelector('.cart_upsell-grid--show [data-tab-loadmore="wishlist"]')
						.classList.add("hidden")
			} else {
				if (document.querySelector('.cart_upsell-grid--show [data-tab-loadmore="wishlist"]'))
					document.querySelector('[data-tab-loadmore="wishlist"]').classList.add("hidden")
				// document.querySelector('[data-tab-loadmore="wishlist"]').classList.add('hidden')
				if (document.querySelector(".cart_upsell-product"))
					document.querySelector(".cart_upsell-product").classList.add("hidden")
				if (document.querySelector(".cart_upsell-grid.empty_block"))
					document.querySelector(".cart_upsell-grid.empty_block").innerHTML =
						"Your wishlist is empty"
			}
		} else {
			document.querySelector('[data-upsell-grid][data-tab="wishlist"]').classList.add("empty_block")
			closeWishlistPupup()
		}

		initRemoveFromWishlist()

		loadmoreCleanup()
	} catch (error) {
		console.error(error)
	}
}

const getWishlistItems = async () => {
	const url = "https://api.myshopapps.com/wishlist/V1/fetchWishlistData/" + window.customerId
	const options = {
		method: "POST",
		headers: {
			xtoken: window.wishlistApiKey,
			"Content-Type": "application/x-www-form-urlencoded",
			Accept: "application/json"
		},
		body: new URLSearchParams({ category_id: "" })
	}

	try {
		const response = await fetch(url, options)
		const data = await response.json()
		if (data.result === undefined) return
		if (data.result.length > 0) {
			checkWishlistItems(data.result)
		}
	} catch (error) {
		console.error(error)
	}
}

const removeItemFromWishlist = async (id, variantId, customerId) => {
	const url = "https://api.myshopapps.com/wishlist/V1/removeWishlist/"
	const options = {
		method: "POST",
		headers: {
			xtoken: window.wishlistApiKey,
			"Content-Type": "application/x-www-form-urlencoded",
			Accept: "application/json"
		},
		body: new URLSearchParams({
			customer_id: window.customerId,
			product_id: Number(id),
			variant_id: Number(variantId),
			category_id: ""
		})
	}

	try {
		await fetch(url, options)
		getWishlist()
		wishListAlert(false)
		if (
			document.querySelectorAll("[data-tab=wishlist] .cart_upsell-product").length === 1 ||
			document.querySelectorAll("[data-tab=wishlist] .cart_upsell-product").length === 0
		)
			document.querySelector(".cart_upsell-grid[data-tab=wishlist]").innerHTML =
				'<span class="cart_upsell-empty">Your wishlist is empty.</span>'
	} catch (error) {
		showWishlistPopup()
	}
}

const wishListAlert = flag => {
	const alert = document.querySelector(".wishlist_alert")
	if (!alert) return
	flag
		? document.querySelector(".wishlist_alert").classList.add("show")
		: document.querySelector(".wishlist_alert").classList.remove("show")
	alert.classList.add("revealAlert")
	setTimeout(() => {
		alert.classList.remove("revealAlert")
	}, 3000)
}

const addItemToWishlist = async (id, variantId, customerId) => {
	const url = "https://api.myshopapps.com/wishlist/V1/addToWishlist/"

	const options = {
		method: "POST",
		headers: {
			xtoken: window.wishlistApiKey,
			"Content-Type": "application/x-www-form-urlencoded",
			Accept: "application/json"
		},
		body: new URLSearchParams({
			customer_id: customerId,
			product_id: Number(id),
			variant_id: Number(variantId),
			category_id: "",
			product_qty: ""
		})
	}

	try {
		await fetch(url, options).then(() => {
			getWishlist()
			wishListAlert(true)
		})
	} catch (error) {
		showWishlistPopup()
	}
}

const stopEvents = e => {
	e.preventDefault()
	e.stopPropagation()
	e.stopImmediatePropagation()
}

const updateCounter = count => {
	const counter = document.querySelector(".icon_cart .tcount")
	if (counter) counter.innerText = count
}

const saveScrollPosition = () => {
	const container = document.querySelector("[data-container]")
	const y = container.scrollTop.toString()

	sessionStorage.setItem("scrollPosition_", y)
}

const restoreScrollPosition = height => {
	const container = document.querySelector("[data-container]")
	const msg = document.querySelector(".cart_drawer--messege")
	const y = height
		? Number(sessionStorage.getItem("scrollPosition_")) + height
		: Number(sessionStorage.getItem("scrollPosition_"))

	container.scrollTo(0, msg.classList.contains("hidden") ? y : y - msg.clientHeight)
}

const getCart = async () => {
	const url = "https://api.myshopapps.com/cart/V1/fetchCart/"
	const options = {
		method: "POST",
		headers: {
			"Content-Type": "application/json"
		}
	}
	const data = await fetch("/cart.json")
	const json = await data.json()
	return json
}

const reloadCart = data => {
	const reload = document.getElementById("cart_drawer_reload")
	const newSection = data.sections.cart_drawer
	const parsed = new DOMParser().parseFromString(newSection, "text/html")
	const newReload = parsed.getElementById("cart_drawer_reload")

	reload.innerHTML = newReload.innerHTML
}

// Update only the dynamic bits (items/empty/totals) without rebuilding the whole drawer.
// This avoids flicker + preserves the upsell DOM and drawer open state.
const patchCartDrawer = cart => {
	if (!cart || !cart.sections || !cart.sections.cart_drawer) return false

	const container = document.querySelector("[data-container]")
	const scrollTop = container ? container.scrollTop : 0

	const parsed = new DOMParser().parseFromString(cart.sections.cart_drawer, "text/html")
	const nextItems = parsed.querySelector(".cart_drawer--items")
	const nextEmpty = parsed.querySelector("[data-cart-empty]")
	const nextTotal = parsed.querySelector("[data-cart-total]")

	const curItems = document.querySelector(".cart_drawer--items")
	const curEmpty = document.querySelector("[data-cart-empty]")
	const curTotal = document.querySelector("[data-cart-total]")

	if (!nextItems || !nextEmpty || !nextTotal || !curItems || !curEmpty || !curTotal) return false

	curItems.replaceWith(nextItems)
	curEmpty.replaceWith(nextEmpty)
	inheritStickyCartTotalState(curTotal, nextTotal)
	curTotal.replaceWith(nextTotal)

	const cartContainer = document.querySelector(".cart_container")
	if (cartContainer) cartContainer.classList.toggle("emptyContainer", cart.item_count === 0)

	if (container) container.scrollTop = scrollTop
	return true
}

const formatMoney = cents => {
	if (window.geckoShopify && typeof window.geckoShopify.formatMoney === "function") {
		return window.geckoShopify.formatMoney(cents)
	}
	if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
		return window.Shopify.formatMoney(cents)
	}
	const amount = (Number(cents) / 100).toFixed(2)
	return `${window.cartDrawer.currencySymbol}${amount}`
}

const replaceCartTotals = cart => {
	if (!cart || !cart.sections || !cart.sections.cart_drawer) return false
	const parsed = new DOMParser().parseFromString(cart.sections.cart_drawer, "text/html")
	const newTotal = parsed.querySelector("[data-cart-total]")
	const currentTotal = document.querySelector("[data-cart-total]")
	if (newTotal && currentTotal) {
		inheritStickyCartTotalState(currentTotal, newTotal)
		currentTotal.replaceWith(newTotal)
		return true
	}
	return false
}

const updateCartTotalFallback = cart => {
	const totalValue = document.querySelector(".cart-drawer-total__value")
	if (!totalValue) return
	totalValue.setAttribute("data-item-counter", cart.item_count)
	totalValue.setAttribute("data-total-price", cart.total_price)
	const label = totalValue.querySelector("span:first-child")
	if (label) {
		label.textContent = label.textContent.replace(/\(\d+\)/, `(${cart.item_count})`)
	}
	const value = totalValue.querySelector("span:last-child")
	if (value) value.textContent = formatMoney(cart.total_price)
}

const syncCartItems = cart => {
	const items = document.querySelectorAll(".cart_drawer--item")
	const itemsByKey = new Map((cart.items || []).map(item => [item.key, item]))
	items.forEach(itemEl => {
		const keyEl =
			itemEl.querySelector("[data-cart-minus]") || itemEl.querySelector("[data-cart-plus]")
		const key = keyEl
			? keyEl.getAttribute("data-cart-minus") || keyEl.getAttribute("data-cart-plus")
			: null
		const cartItem = key ? itemsByKey.get(key) : null
		if (!cartItem) {
			itemEl.remove()
			return
		}
		const qtyEl = itemEl.querySelector(".cart_drawer--item__quantity-value")
		if (qtyEl) qtyEl.innerText = cartItem.quantity
		const qtyWrap = itemEl.querySelector(".cart_drawer--item__quantity")
		if (qtyWrap) qtyWrap.classList.remove("cart_drawer--item__quantity--changing")
		const removeBtn = itemEl.querySelector("[data-cart-remove]")
		if (removeBtn) {
			removeBtn.setAttribute("data-cart-remove-quantity", cartItem.quantity)
			removeBtn.setAttribute("data-cart-items", cart.item_count)
		}
	})
	document.querySelectorAll(".cart_drawer--item__quantity--changing").forEach(el => {
		el.classList.remove("cart_drawer--item__quantity--changing")
	})
	document.querySelectorAll("[data-cart-remove]").forEach(btn => {
		btn.setAttribute("data-cart-items", cart.item_count)
	})
}

const update = async (url, options) => {
	const opts = options && typeof options === "object" ? options : {}
	setShippingUpdating(true)
	const cart = await fetchData(url)
	const currentItemsCount = document.querySelectorAll(".cart_drawer--item").length
	const cartItemsCount = Array.isArray(cart.items) ? cart.items.length : 0
	const fastPath = opts.fast === true && currentItemsCount === cartItemsCount
	if (fastPath) {
		syncCartItems(cart)
		if (!replaceCartTotals(cart)) updateCartTotalFallback(cart)
	} else {
		reloadCart(cart)
	}
	checkIfCartIsEmpty(cart.item_count)

	if (cart.item_count) {
		updateCounter(cart.item_count)
	} else {
		const q = document.querySelectorAll(".cart_drawer--item__quantity-value")
		let qa = 0
		q.forEach(el => {
			qa = qa + Number(el.textContent)
		})
		updateCounter(qa)
	}

	// saveScrollPosition()
	currentTotalPrice = cart.total_price / 100
	if (fastPath) {
		updateShipping(cart.total_price)
	} else {
		await renderUpsell()
		setTimeout(async () => {
			updateShipping(cart.total_price)
			await getWishlist()
			checkIfCartIsEmpty(cart.item_count)
		}, 10)
	}

	setupStickyCartTotal()
}

const fetchData = async url => {
	const data = await fetch(url, {
		method: "POST",
		headers: {
			"Content-Type": "application/json"
		}
	})
	const json = await data.json()
	showErrorMessege(json.message)

	return json
}

const addItem = async (id, flag, quantity = 1) =>
	await update(`/cart/add.js?id=${id}&quantity=${quantity}&sections=cart_drawer`, flag, quantity)
const removeItem = async (id, flag, quantity = 0) =>
	await update(`/cart/change.js?id=${id}&quantity=${quantity}&sections=cart_drawer`, flag, quantity)
const decreaseQuantity = async (id, quantity) =>
	await update(`/cart/change.js?id=${id}&quantity=${Number(quantity) - 1}&sections=cart_drawer`, {
		fast: true
	})
const increaseQuantity = async (id, quantity) =>
	await update(`/cart/change.js?id=${id}&quantity=${Number(quantity) + 1}&sections=cart_drawer`, {
		fast: true
	})

const getCartItemStateByKey = key => {
	const removeBtn = Array.from(document.querySelectorAll("[data-cart-remove]")).find(
		el => el.getAttribute("data-cart-remove") === key
	)
	const qtyFromAttr = removeBtn ? Number(removeBtn.getAttribute("data-cart-remove-quantity")) : NaN
	const qtyFromDom = removeBtn
		? Number(
				removeBtn
					.closest(".cart_drawer--item")
					?.querySelector(".cart_drawer--item__quantity-value")?.textContent
		  )
		: NaN
	const qty = Number.isFinite(qtyFromAttr) ? qtyFromAttr : Number.isFinite(qtyFromDom) ? qtyFromDom : 1
	const variantId = removeBtn ? removeBtn.getAttribute("data-cart-remove-product") : ""
	return { qty: Math.max(1, qty || 1), variantId: variantId || "" }
}

const bindCartDrawerLineItemControls = (root = document) => {
	root.querySelectorAll("[data-cart-remove]").forEach(btn => {
		onOnce(btn, "click", async () => {
			const id = btn.getAttribute("data-cart-remove")
			await fadeOut(btn.closest(".cart_drawer--item"))

			if (btn.closest(".cart_drawer--item")) {
				btn.closest(".cart_drawer--item").remove()
				if (btn.getAttribute("data-cart-items") === "1") {
					const bar = document.querySelector(".cart-shipping_bar")
					if (bar) bar.classList.add("hidden")
					const total = document.querySelector("[data-cart-total]").classList.add("hidden")
					if (total) total.classList.add("hidden")
					const items = document.querySelector(".cart_drawer--items")
					if (items) items.classList.add("hidden")
					const empty = document.querySelector("[data-cart-empty]")
					if (empty) empty.classList.remove("hidden")
				}
			}

			const title = btn.getAttribute("data-title")
			if (title) showMessege(window.cartDrawer.removeFromCart.replace("{{title}}", title))
			await removeItem(id, true)
			if (title) showMessege(window.cartDrawer.removeFromCart.replace("{{title}}", title))
			const productId = btn.getAttribute("data-cart-remove-product")
			const quantity = btn.getAttribute("data-cart-remove-quantity")
			document.querySelector(".cart_drawer--messege__undo").setAttribute("data-action", "add")
			if (productId)
				document.querySelector(".cart_drawer--messege__undo").setAttribute("data-id", productId)
			if (quantity)
				document
					.querySelector(".cart_drawer--messege__undo")
					.setAttribute("data-quantity", quantity)
		})
	})

	root.querySelectorAll("[data-cart-minus]").forEach(btn => {
		onOnce(btn, "click", async () => {
			const id = btn.getAttribute("data-cart-minus")
			const q = btn
				.closest(".cart_drawer--item__quantity")
				.querySelector(".cart_drawer--item__quantity-value").innerText
			btn
				.closest(".cart_drawer--item__quantity")
				.querySelector(".cart_drawer--item__quantity-value").innerText =
				Number(q) - 1
			if (btn.closest(".cart_drawer--item__quantity")) {
				btn
					.closest(".cart_drawer--item__quantity")
					.classList.add("cart_drawer--item__quantity--changing")
			}
			if (Number(q) === 1) {
				fadeOut(btn.closest(".cart_drawer--item"))
			}
			decreaseQuantity(id, q)
		})
	})

	root.querySelectorAll("[data-cart-plus]").forEach(btn => {
		onOnce(btn, "click", async () => {
			const id = btn.getAttribute("data-cart-plus")
			const q = btn
				.closest(".cart_drawer--item__quantity")
				.querySelector(".cart_drawer--item__quantity-value").innerText
			btn
				.closest(".cart_drawer--item__quantity")
				.querySelector(".cart_drawer--item__quantity-value").innerText =
				Number(q) + 1
			if (btn.closest(".cart_drawer--item__quantity")) {
				btn
					.closest(".cart_drawer--item__quantity")
					.classList.add("cart_drawer--item__quantity--changing")
			}
			increaseQuantity(id, q)
		})
	})

	root.querySelectorAll("[data-change-product]").forEach(btn => {
		onOnce(btn, "click", async () => {
			const handle = btn.getAttribute("data-change-product")
			if (!handle) return
			const id = btn.getAttribute("data-change-id")
			if (id) sessionStorage.setItem("cart_change_id", id)
			const fromUpsell = btn.closest(".cart_upsell-product__variants") ? true : false
			if (fromUpsell) sessionStorage.removeItem("cart_change_id")

			document.body.classList.add("popup_edit")
			await window.updateCartSectionAsync(handle)
			window.updateCartSectionOpener()
			setTimeout(() => {
				const size = btn.getAttribute("product-change-size")
				if (size) {
					const sizeEl = document.querySelectorAll(
						`#shopify-section-product_popup .prdsctcst__variant-list-item`
					)
					sizeEl.forEach(el => {
						if (el.querySelector("input").value.trim() === size.trim()) {
							el.querySelector("label").click()
						}
					})
				}
			}, 500)
		})
	})

	root.querySelectorAll("[wishlist_btn_product_card]").forEach(el => {
		onOnce(el, "click", async e => {
			stopEvents(e)
			const id = el.getAttribute("data-id")
			const variantId = el.getAttribute("data-variant-id")
			const upsellProd = el.closest(".cart_upsell-product")
			if (upsellProd) upsellProd.style.opacity = 0.5
			if (window.customerId === "") {
				showWishlistPopup()
				return
			} else {
				if (el.classList.contains("added")) {
					await removeItemFromWishlist(id, variantId, Number(window.customerId))
					el.classList.remove("added")
				} else {
					await addItemToWishlist(id, variantId, Number(window.customerId))
					el.classList.add("added")
				}
			}
			if (upsellProd) upsellProd.style.opacity = 1
		})
	})
}

const swapCartItemVariant = async (lineItemKey, nextVariantId) => {
	if (!lineItemKey || !nextVariantId) return
	const { qty, variantId } = getCartItemStateByKey(lineItemKey)
	if (variantId && String(variantId) === String(nextVariantId)) return

	const drawer = document.getElementById("cart_drawer_reload")
	if (drawer) drawer.setAttribute("data-update-kind", "variant")

	const removeBtn = Array.from(document.querySelectorAll("[data-cart-remove]")).find(
		el => el.getAttribute("data-cart-remove") === lineItemKey
	)
	const itemEl = removeBtn ? removeBtn.closest(".cart_drawer--item") : null
	if (itemEl) itemEl.classList.add("is-loading")

	setShippingUpdating(true)

	try {
		// Remove old line item, then add the new variant with the same quantity.
		await fetchData(`/cart/change.js?id=${encodeURIComponent(lineItemKey)}&quantity=0`)
		const cart = await fetchData(
			`/cart/add.js?id=${Number(nextVariantId)}&quantity=${Number(qty)}&sections=cart_drawer`
		)

		// Partial patch (avoid full drawer rebuild).
		const patched = patchCartDrawer(cart)
		if (!patched) reloadCart(cart)

		// Re-bind controls for the newly-rendered line items.
		const itemsRoot = document.querySelector(".cart_drawer--items")
		if (itemsRoot) bindCartDrawerLineItemControls(itemsRoot)

		checkIfCartIsEmpty(cart.item_count)

		if (cart.item_count) {
			updateCounter(cart.item_count)
		} else {
			const q = document.querySelectorAll(".cart_drawer--item__quantity-value")
			let qa = 0
			q.forEach(el => {
				qa = qa + Number(el.textContent)
			})
			updateCounter(qa)
		}

		currentTotalPrice = cart.total_price / 100
		await updateShipping(cart.total_price)
		setupStickyCartTotal()
	} finally {
		if (drawer) drawer.removeAttribute("data-update-kind")
		if (itemEl) itemEl.classList.remove("is-loading")
		setShippingUpdating(false)
	}
}

const closeCart = () => {
	const atcDrawer = document.querySelector("#prdsctcst")
	if (atcDrawer) atcDrawer.classList.remove("show")
	document.documentElement.classList.remove("cart_fade_in")
	cleanupStickyCartTotal()

	setTimeout(() => {
		document.documentElement.classList.remove("cart_change_index")
	}, 400)
}

const openCart = e => {
	if (e) stopEvents(e)
	document.documentElement.classList.add("cart_block")
	setTimeout(() => {
		document.documentElement.classList.add("cart_change_index")
		document.documentElement.classList.add("cart_fade_in")
		setupStickyCartTotal()
	}, 10)
	updateShipping(currentTotalPrice)
}

const showErrorMessege = text => {
	// const messege = document.querySelector('.cart_drawer--messege--error')
	// if (messege) {
	//   const textEl = messege.querySelector('[cart-banner-text]')
	//   textEl.innerHTML = text
	//   messege.classList.remove('hidden')
	// }
}

const showMessege = text => {
	const messege = document.querySelector(".cart_drawer--messege")
	if (messege) {
		const textEl = messege.querySelector("[cart-banner-text]")
		textEl.innerHTML = text
		messege.classList.remove("hidden")
	}
}

const hideMessege = () => {
	const messege = document.querySelector(".cart_drawer--messege")
	if (messege) {
		const textEl = messege.querySelector("[cart-banner-text]")
		textEl.innerHTML = ""
		messege.classList.add("hidden")
	}
}
const fadeOut = el => {
	return new Promise(resolve => {
		el.style.transition = "opacity 0.4s"
		el.style.opacity = 0
		setTimeout(() => {
			resolve()
		}, 400)
	})
}

const initRemoveFromWishlist = () => {
	document.querySelectorAll(".cart_upsell-remove-from-wishlist").forEach(el => {
		el.addEventListener("click", async e => {
			stopEvents(e)
			const id = el.getAttribute("data-id")
			const variantId = el.getAttribute("data-variant-id")
			const customerId = el.getAttribute("data-customer-id")
			el.closest(".cart_upsell-product").style.opacity = 0.5
			await removeItemFromWishlist(id, variantId, customerId)
		})
	})
}

const addEventWishlistBtn = () => {
	document.querySelectorAll('[data-id="#nt_wishlist"]').forEach(el => {
		el.addEventListener("click", async e => {
			stopEvents(e)
			openCart()
			if (window.customerId === "") {
				showWishlistPopup()
			}
		})
	})
	document.querySelectorAll(".iWishView.mst-wishlist-desktop").forEach(el => {
		el.addEventListener("click", async e => {
			stopEvents(e)
			openWishlistDrawer(e)
		})
	})
}

const checkWishlistItems = async items => {
	items.forEach(item => {
		if (document.querySelector('.wishlist_btn_product_card[data-id="' + item.id + '"]')) {
			document
				.querySelectorAll('.wishlist_btn_product_card[data-id="' + item.id + '"]')
				.forEach(el => {
					el.classList.add("added")
				})
		}
	})
}
const pages = {
	upsell: 0,
	wishlist: 0
}

const fixLoadmore = e => {
	if (document.querySelector("[data-upsell-grid] .cart_upsell-product").length < 5) {
		document.querySelector("[data-upsell-grid] .cart_upsell-product").forEach((el, i) => {
			console.log(i, upsellPage * 4)

			if (i < 4 * upsellPage) {
				el.classList.add("hidden")
			} else {
				el.classList.remove("hidden")
			}
		})
	}
	if (e.target.getAttribute("data-tab-loadmore") === "upsell") {
		upsellPage = upsellPage + 1
	}
}

// Ensure a given element only gets one listener, even if init() runs again
function onOnce(el, type, handler) {
  const key = '__bound_' + type;
  if (el[key]) return;
  el[key] = true;
  el.addEventListener(type, handler);
}

let stickyCartTotalRaf = null

// When Shopify section HTML replaces `[data-cart-total]` (fast-path quantity updates),
// keep the mobile sticky state so the footer doesn't "jump" back into the flow for a frame.
function inheritStickyCartTotalState(prevTotal, nextTotal) {
	if (!prevTotal || !nextTotal) return

	const portal = document.querySelector("[data-cart-total-portal]")
	const wasPortaled = portal && portal.contains(prevTotal)
	const wasSticky = prevTotal.classList.contains("is-sticky-mobile") || wasPortaled

	if (!wasSticky) return

	nextTotal.classList.add("is-sticky-mobile")

	// Preserve any cached measurements used by the sticky logic.
	if (prevTotal.dataset.flowHeight) nextTotal.dataset.flowHeight = prevTotal.dataset.flowHeight
	if (prevTotal.dataset.dockBottomOffset)
		nextTotal.dataset.dockBottomOffset = prevTotal.dataset.dockBottomOffset

	// Ensure the portal stays "active" if we're already sticky.
	if (portal) portal.setAttribute("aria-hidden", "false")
}

const ensureCartTotalPortal = () => {
	const drawer = document.querySelector(".cart_drawer")
	if (!drawer) return null
	let portal = drawer.querySelector("[data-cart-total-portal]")
	if (portal) return portal
	portal = document.createElement("div")
	portal.setAttribute("data-cart-total-portal", "")
	portal.setAttribute("aria-hidden", "true")
	drawer.appendChild(portal)
	return portal
}

const cleanupStickyCartTotal = () => {
	if (stickyCartTotalRaf) {
		cancelAnimationFrame(stickyCartTotalRaf)
		stickyCartTotalRaf = null
	}

	const container = document.querySelector(".cart_container")
	const total = document.querySelector("[data-cart-total]")
	const placeholder = container
		? container.querySelector("[data-cart-total-placeholder]")
		: document.querySelector("[data-cart-total-placeholder]")
	const portal = document.querySelector("[data-cart-total-portal]")

	if (total && placeholder) {
		// If we had moved the totals to the portal, restore it back into the flow.
		if (!total.parentElement || total.parentElement !== placeholder.parentElement) {
			placeholder.insertAdjacentElement("beforebegin", total)
		}
	}
	if (container && total && !container.contains(total)) {
		// Fallback: if placeholder is missing but totals are still portaled, put them back in the drawer content.
		const wrap = container.firstElementChild || container
		wrap.appendChild(total)
	}

	if (total) total.classList.remove("is-sticky-mobile")
	if (total) delete total.dataset.flowHeight
	if (total) delete total.dataset.dockBottomOffset
	if (placeholder) placeholder.remove()
	if (portal && portal.childElementCount === 0) portal.remove()
}

const scheduleStickyCartTotalUpdate = () => {
	if (stickyCartTotalRaf) return
	stickyCartTotalRaf = requestAnimationFrame(() => {
		stickyCartTotalRaf = null
		const container = document.querySelector(".cart_container")
		if (!container) return
		updateStickyCartTotal(container)
	})
}

// Mobile-only "sticky checkout" that re-uses the SAME totals element (no clone).
// We toggle `is-sticky-mobile` on `[data-cart-total]` and leave a placeholder in-flow
// so scroll height doesn't jump when the element becomes `position: fixed`.
const setupStickyCartTotal = () => {
	const container = document.querySelector(".cart_container")
	if (!container) return

	// Re-evaluate while the drawer scrolls.
	onOnce(container, "scroll", scheduleStickyCartTotalUpdate)

	// Re-evaluate on resize/orientation changes (bound once globally).
	onOnce(window, "resize", scheduleStickyCartTotalUpdate)

	scheduleStickyCartTotalUpdate()
}

const updateStickyCartTotal = container => {
	const total = container.querySelector("[data-cart-total]") || document.querySelector("[data-cart-total]")
	if (!total) return

	const isMobile = window.matchMedia && window.matchMedia("(max-width: 768px)").matches
	const drawerOpen = document.documentElement.classList.contains("cart_fade_in")
	const canShow = isMobile && drawerOpen && !total.classList.contains("hidden")

	const placeholder =
		container.querySelector("[data-cart-total-placeholder]") ||
		document.querySelector("[data-cart-total-placeholder]")

	// If the drawer can't scroll, don't sticky-fix the footer (it would look like a duplicate UI).
	const canScroll = container.scrollHeight - container.clientHeight > 4

	if (!canShow || !canScroll) {
		// If totals were portaled, restore them back into the drawer content.
		const portal = document.querySelector("[data-cart-total-portal]")
		if (portal && portal.contains(total)) {
			portal.setAttribute("aria-hidden", "true")
			const wrap = container.firstElementChild || container
			wrap.appendChild(total)
				if (portal.childElementCount === 0) portal.remove()
		}
		total.classList.remove("is-sticky-mobile")
		delete total.dataset.flowHeight
		delete total.dataset.dockBottomOffset
		if (placeholder) placeholder.remove()
		return
	}

	const containerRect = container.getBoundingClientRect()
	const dockTarget = total.querySelector(".cart-drawer-total__btns") || total
	const STICKY_ENTER_PX = 12 // how many pixels of the button area must be cut off before we "stick"
	const STICKY_EXIT_PX = 2 // how many pixels of clearance we require before we "unstick" (hysteresis)

	// If the totals node is already portaled (e.g. it was sticky before a cart refresh),
	// but got replaced during update() (losing its class), treat it as sticky to avoid a jump.
	const existingPortal = document.querySelector("[data-cart-total-portal]")
	const isPortaled = existingPortal && existingPortal.contains(total)
	if (isPortaled && !total.classList.contains("is-sticky-mobile")) {
		total.classList.add("is-sticky-mobile")
	}

	const ensurePlaceholder = flowHeight => {
		if (placeholder) {
			placeholder.style.height = `${flowHeight}px`
			return placeholder
		}
		const ph = document.createElement("div")
		ph.setAttribute("data-cart-total-placeholder", "")
		ph.setAttribute("aria-hidden", "true")
		ph.style.height = `${flowHeight}px`
		ph.style.pointerEvents = "none"
		ph.style.position = "relative"

		// If totals are still in-flow, insert right after them.
		if (container.contains(total)) {
			total.insertAdjacentElement("afterend", ph)
			return ph
		}

		// If totals are currently portaled (sticky), fall back to the main content wrapper.
		const wrap = container.firstElementChild
		if (wrap) {
			wrap.appendChild(ph)
			return ph
		}
		container.appendChild(ph)
		return ph
	}

	const ensureDockSentinel = (ph, dockBottomOffsetPx) => {
		let s = ph.querySelector("[data-cart-total-dock-sentinel]")
		if (!s) {
			s = document.createElement("div")
			s.setAttribute("data-cart-total-dock-sentinel", "")
			s.setAttribute("aria-hidden", "true")
			s.style.position = "absolute"
			s.style.left = "0"
			s.style.right = "0"
			s.style.height = "0"
			s.style.pointerEvents = "none"
			ph.appendChild(s)
		}
		const phHeight = ph.getBoundingClientRect().height
		const clampedTop = Math.max(0, Math.min(dockBottomOffsetPx, phHeight))
		s.style.top = `${clampedTop}px`
		return s
	}

	// Sticky state: stay sticky ONLY while the original checkout button area would still be cut off
	// below the drawer viewport. Once that bottom edge comes into view, restore it in-flow and keep it there.
	if (total.classList.contains("is-sticky-mobile")) {
		const flowHeight =
			Number(total.dataset.flowHeight || 0) || Math.ceil(total.getBoundingClientRect().height)
		const ph = ensurePlaceholder(flowHeight)
		const dockBottomOffset =
			Number(total.dataset.dockBottomOffset || 0) ||
			(dockTarget.getBoundingClientRect().bottom - total.getBoundingClientRect().top)
		const sentinel = ensureDockSentinel(ph, dockBottomOffset)
		const sentinelRect = sentinel.getBoundingClientRect()
		const delta = sentinelRect.top - containerRect.bottom
		const shouldStaySticky = delta > -STICKY_EXIT_PX

		if (!shouldStaySticky) {
			total.classList.remove("is-sticky-mobile")
			delete total.dataset.flowHeight
			delete total.dataset.dockBottomOffset
			ph.insertAdjacentElement("beforebegin", total)
			ph.remove()
			const portal = document.querySelector("[data-cart-total-portal]")
			if (portal) {
				portal.setAttribute("aria-hidden", "true")
				if (portal.childElementCount === 0) portal.remove()
			}
		}
		return
	}

	// Not sticky: clear any stray placeholder left after partial DOM replacements.
	if (placeholder) placeholder.remove()

	const dockRect = dockTarget.getBoundingClientRect()
	const delta = dockRect.bottom - containerRect.bottom
	const shouldStick = delta > STICKY_ENTER_PX

	if (shouldStick) {
		const portal = ensureCartTotalPortal()
		if (!portal) return

		const flowHeight = Math.ceil(total.getBoundingClientRect().height)
		total.dataset.flowHeight = String(flowHeight)
		const ph = ensurePlaceholder(flowHeight)
		const dockBottomOffset = dockRect.bottom - total.getBoundingClientRect().top
		total.dataset.dockBottomOffset = String(dockBottomOffset)
		ensureDockSentinel(ph, dockBottomOffset)

		// Move the SAME element outside the transformed scroll container so `position: fixed`
		// actually sticks to the viewport (avoids the "fixed-inside-transform" bug).
		portal.setAttribute("aria-hidden", "false")
		portal.appendChild(total)
		total.classList.add("is-sticky-mobile")
	} else {
		// Ensure we are in-flow when the original checkout area is visible/past (not cut off).
		const portal = document.querySelector("[data-cart-total-portal]")
		if (portal && portal.contains(total)) {
			portal.setAttribute("aria-hidden", "true")
			const wrap = container.firstElementChild || container
			wrap.appendChild(total)
		}
		total.classList.remove("is-sticky-mobile")
		delete total.dataset.flowHeight
		delete total.dataset.dockBottomOffset
	}
}

const init = () => {
	const btns = {
		remove: document.querySelectorAll("[data-cart-remove]"),
		quantity: {
			minus: document.querySelectorAll("[data-cart-minus]"),
			plus: document.querySelectorAll("[data-cart-plus]")
		},
		sizes: document.querySelectorAll(".cart_upsell-variants__size"),
		swatches: document.querySelectorAll(".cart_upsell-product .cart_upsell-variants__color"),
		close_cart: document.querySelector(".cart_x"),
		open_cart: document.querySelectorAll('[href="/cart"]:not(.cart-btn)'),
		loadmore: document.querySelectorAll("[data-loadmore]"),
		tabControls: document.querySelectorAll("[data-tab-control]"),
		atc: document.querySelectorAll(".single_add_to_cart_button"),
		change: document.querySelectorAll("[data-change-product]")
	}

	btns.remove.forEach(btn => {
		onOnce(btn,"click", async () => {
			const id = btn.getAttribute("data-cart-remove")
			await fadeOut(btn.closest(".cart_drawer--item"))

			if (btn.closest(".cart_drawer--item")) {
				btn.closest(".cart_drawer--item").remove()
				if (btn.getAttribute("data-cart-items") === "1") {
					const bar = document.querySelector(".cart-shipping_bar")
					if (bar) bar.classList.add("hidden")
					const total = document.querySelector("[data-cart-total]").classList.add("hidden")
					if (total) total.classList.add("hidden")
					const items = document.querySelector(".cart_drawer--items")
					if (items) items.classList.add("hidden")
					const empty = document.querySelector("[data-cart-empty]")
					if (empty) empty.classList.remove("hidden")
				}
			}

			const title = btn.getAttribute("data-title")
			if (title) showMessege(window.cartDrawer.removeFromCart.replace("{{title}}", title))
			await removeItem(id, true)
			if (title) showMessege(window.cartDrawer.removeFromCart.replace("{{title}}", title))
			const productId = btn.getAttribute("data-cart-remove-product")
			const quantity = btn.getAttribute("data-cart-remove-quantity")
			document.querySelector(".cart_drawer--messege__undo").setAttribute("data-action", "add")
			if (productId)
				document.querySelector(".cart_drawer--messege__undo").setAttribute("data-id", productId)
			if (quantity)
				document
					.querySelector(".cart_drawer--messege__undo")
					.setAttribute("data-quantity", quantity)
		})
	})

	btns.quantity.minus.forEach(btn => {
		onOnce(btn,"click", async () => {
			const id = btn.getAttribute("data-cart-minus")
			const q = btn
				.closest(".cart_drawer--item__quantity")
				.querySelector(".cart_drawer--item__quantity-value").innerText
			btn
				.closest(".cart_drawer--item__quantity")
				.querySelector(".cart_drawer--item__quantity-value").innerText =
				Number(q) - 1
			if (btn.closest(".cart_drawer--item__quantity")) {
				btn
					.closest(".cart_drawer--item__quantity")
					.classList.add("cart_drawer--item__quantity--changing")
			}
			if (Number(q) === 1) {
				fadeOut(btn.closest(".cart_drawer--item"))
			}
			decreaseQuantity(id, q)
		})
	})
	const undo = document.querySelector(".cart_drawer--messege__undo")
	if (undo)
		undo.addEventListener("click", async e => {
			const id = document.querySelector(".cart_drawer--messege__undo").getAttribute("data-id")
			const quantity = document
				.querySelector(".cart_drawer--messege__undo")
				.getAttribute("data-quantity")

			if (
				document.querySelector(".cart_drawer--messege__undo").getAttribute("data-action") === "add"
			) {
				await addItem(Number(id), true, quantity)
				hideMessege()
			} else {
				await removeItem(Number(id), true, quantity)
				hideMessege()
			}
		})

	btns.quantity.plus.forEach(btn => {
		onOnce(btn,"click", async () => {
			const id = btn.getAttribute("data-cart-plus")
			const q = btn
				.closest(".cart_drawer--item__quantity")
				.querySelector(".cart_drawer--item__quantity-value").innerText
			btn
				.closest(".cart_drawer--item__quantity")
				.querySelector(".cart_drawer--item__quantity-value").innerText =
				Number(q) + 1
			if (btn.closest(".cart_drawer--item__quantity")) {
				btn
					.closest(".cart_drawer--item__quantity")
					.classList.add("cart_drawer--item__quantity--changing")
			}
			increaseQuantity(id, q)
		})
	})

	btns.close_cart.addEventListener("click", closeCart)
	btns.open_cart.forEach(btn => btn.addEventListener("click", openCart))

	btns.tabControls.forEach(btn => {
		btn.addEventListener("click", () => {
			const currentTab = btn.getAttribute("data-tab-control")
			const tabs = document.querySelectorAll("[data-tab]")

			tabs.forEach(tab => {
				if (tab.getAttribute("data-tab") !== currentTab) return
				if (window.customerId === "") {
					showWishlistPopup()
					return
				}
				tabs.forEach(tab => {
					tab.classList.add("hidden")
				})
				btns.tabControls.forEach(btn => {
					btn.classList.remove("selected")
				})
				btn.classList.add("selected")
				tab.classList.remove("hidden")
			})

			setTimeout(() => {
				loadmoreCleanup()
			}, 500)
		})
	})
	const w_list = document.querySelector('[data-tab-control="wishlist"]')
	if (w_list)
		w_list.addEventListener("click", () => {
			getWishlist()
		})

	btns.loadmore.forEach(btn => {
		btn.addEventListener("click", () => {
			const currentTab = btn.getAttribute("data-tab-loadmore")
			const collections = document.querySelectorAll("[data-upsell-grid]")
			collections.forEach((collection, i) => {
				if (collection.getAttribute("data-tab") !== currentTab) return
				const prds = document.querySelectorAll(
					"[data-upsell-grid][data-tab=" + currentTab + "] .cart_upsell-product"
				).length

				// collection.classList.add('cart_upsell-grid--show').classList.add('hidden')

				// if (prds > 6 && document.querySelector('.selected[data-tab-control="w"]')) {
				btn.classList.add("hidden")
				// }
			})
			if (btn.getAttribute("data-tab-loadmore") === "upsell") {
				document
					.querySelector('[data-upsell-grid][data-tab="upsell"]')
					.classList.add("cart_upsell-grid--show")
				document.querySelector("[data-tab-loadmore=upsell]").classList.add("hidden")
			} else {
				document
					.querySelector('[data-upsell-grid][data-tab="wishlist"]')
					.classList.add("cart_upsell-grid--show")
			}
		})
	})

	document.addEventListener("click", async e => {
		if (e.target.classList.contains("prdsctcst__cont-form-btn")) {
			stopEvents(e)
			const id = e.target.closest("form").querySelector("#variant_select").selectedOptions
				? e.target.closest("form").querySelector("#variant_select").selectedOptions[0].value
				: e.target.closest("form").querySelector("#variant_select").value

			if (!id) return
			if (id === 0 || id === "0") return

			const changeId = sessionStorage.getItem("cart_change_id")
			if (changeId) {
				await swapCartItemVariant(changeId, id)
				sessionStorage.removeItem("cart_change_id")
				document.body.classList.remove("popup_edit")
			} else {
				addItem(Number(id))
			}
			openCart(e)
		}
	})

	document.addEventListener("click", async e => {
		if (
			e.target.classList.contains("product_popup_opener") ||
			e.target.closest(".product_popup_opener")
		) {
			stopEvents(e)
			const handle =
				e.target.getAttribute("data-handle") ||
				e.target.closest(".product_popup_opener").getAttribute("data-handle")
			if (!handle) return
			await updateCartSectionAsync(handle)
			closeCart()
			updateCartSectionOpener()
			return
		}
		if (
			e.target.classList.contains("single_add_to_cart_button") &&
			e.target.closest(".variations_form_ppr")
		) {
			if (
				e.target.closest("#cart-form_ppr") &&
				e.target
					.closest("#cart-form_ppr")
					.querySelector("#swatchListSize .swatch_pr_item.is-selected") === null
			) {
				return
			}
			const changeId = sessionStorage.getItem("cart_change_id")

			if (changeId) {
				await removeItem(changeId)
				sessionStorage.removeItem("cart_change_id")
			}
			updateQuickAddText()
			const id = e.target.closest("form").querySelector("#variant_select").value
			if (!id) return
			addItem(Number(id))
		}
	})

	btns.atc.forEach(btn => {
		btn.addEventListener("click", async e => {
			if (
				e.target.closest("#cart-form_ppr") &&
				e.target.closest("#cart-form_ppr").querySelector("#swatchListSize")
			) {
				if (
					e.target
						.closest("#cart-form_ppr")
						.querySelector("#swatchListSize .swatch_pr_item.is-selected") === null
				) {
					return
				}
				const changeId = sessionStorage.getItem("cart_change_id")
				if (changeId) {
					await removeItem(changeId)
					sessionStorage.removeItem("cart_change_id")
				}
				const id = btn.closest("form").querySelector("[data-productid]").selectedOptions
					? btn.closest("form").querySelector("[data-productid]").selectedOptions[0].value
					: btn.closest("form").querySelector("[data-productid]").value
				if (!id) return
				stopEvents(e)

				addItem(Number(id))
				openCart(e)
				const counter = document.querySelector(".icon_cart .tcount")
				if (counter) counter.innerText = Number(counter.innerText) + 1
			} else {
				const changeId = sessionStorage.getItem("cart_change_id")
				if (changeId) {
					await removeItem(changeId)
					sessionStorage.removeItem("cart_change_id")
				}
				const id = btn.closest("form").querySelector("[data-productid]").selectedOptions
					? btn.closest("form").querySelector("[data-productid]").selectedOptions[0].value
					: btn.closest("form").querySelector("[data-productid]").value
				if (!id) return
				addItem(Number(id))
				openCart(e)
			}
		})
	})

	btns.sizes.forEach(btn => {
		btn.addEventListener("click", async e => {
			const id = btn.getAttribute("data-id")
			if (!id) return
			const title = btn.getAttribute("data-title")

			if (title) showMessege(window.cartDrawer.addedToCart.replace("{{title}}", title))
			await addItem(Number(id), true)
			if (title) showMessege(window.cartDrawer.addedToCart.replace("{{title}}", title))

			let quantity = 2
			const quantityEls = document.querySelectorAll("[data-cart-remove-product]")
			quantityEls.forEach(el => {
				if (el.getAttribute("data-cart-remove-product") === id) {
					quantity = Number(el.getAttribute("data-cart-remove-quantity"))
				}
			})

			document.querySelector(".cart_drawer--messege__undo").setAttribute("data-action", "remove")
			document.querySelector(".cart_drawer--messege__undo").setAttribute("data-id", id)
			document
				.querySelector(".cart_drawer--messege__undo")
				.setAttribute("data-quantity", quantity - 1)
		})
	})

	btns.swatches.forEach(btn => {
		btn.addEventListener("click", async e => {
			if (window.innerWidth > 760) {
				const handle = btn.getAttribute("data-change-product")
				if (!handle) return
				const id = btn.getAttribute("data-change-id")
				if (id) sessionStorage.setItem("cart_change_id", id)
				window.updateCartSection(handle)
				// window.updateCartSectionOpener()
			}
		})
	})

	btns.change.forEach(btn => {
		btn.addEventListener("click", async e => {
			const handle = btn.getAttribute("data-change-product")
			if (!handle) return
			const id = btn.getAttribute("data-change-id")
			if (id) sessionStorage.setItem("cart_change_id", id)
			const fromUpsell = btn.closest(".cart_upsell-product__variants") ? true : false
			if (fromUpsell) sessionStorage.removeItem("cart_change_id")

			document.body.classList.add("popup_edit")
			await window.updateCartSectionAsync(handle)
			window.updateCartSectionOpener()
			setTimeout(() => {
				const size = btn.getAttribute("product-change-size")
				if (size) {
					const sizeEl = document.querySelectorAll(
						`#shopify-section-product_popup .prdsctcst__variant-list-item`
					)
					sizeEl.forEach(el => {
						if (el.querySelector("input").value.trim() === size.trim()) {
							el.querySelector("label").click()
						}
					})
				}
			}, 500)
		})
	})

	document.querySelectorAll(".cart_upsell-product a").forEach(el => {
		el.addEventListener("click", e => {
			if (window.innerWidth < 767) {
				stopEvents(e)
				const parent = e.target.closest(".cart_upsell-product")
				if (!parent) return
				const opener = parent.querySelector(".product_popup_opener")
				if (opener) opener.click()
				return
			}
		})
	})
	const container = document.querySelector("[data-container]")
	container.addEventListener("scroll", () => {
		sessionStorage.setItem("scrollPosition_", container.scrollTop)
	})
	updateShipping(window.cartDrawer.totalPrice)
	const reloadSection = document.querySelector("#cart_drawer_reload")
	if (reloadSection) {
		reloadSection.addEventListener("click", e => {
			if (e.target === reloadSection) {
				sessionStorage.removeItem("cart_change_id")
				document.body.classList.remove("popup_edit")
				closeCart()
			}
		})
	}
	const overl = document.querySelector(".prdsctcst__overlay")
	if (overl) {
		overl.addEventListener("click", e => {
			if (e.target === overl) {
				sessionStorage.removeItem("cart_change_id")
				document.body.classList.remove("popup_edit")
			}
		})
	}
	document.addEventListener("click", e => {
		if (e.target.className === "cart_drawer-popup") closeWishlistPupup()
	})

	document.querySelectorAll("[wishlist_btn_product_card]").forEach(el => {
		el.addEventListener("click", async e => {
			stopEvents(e)
			const id = el.getAttribute("data-id")
			const variantId = el.getAttribute("data-variant-id")
			const upsellProd = el.closest(".cart_upsell-product")
			if (upsellProd) upsellProd.style.opacity = 0.5
			if (window.customerId === "") {
				showWishlistPopup()
				return
			} else {
				if (el.classList.contains("added")) {
					await removeItemFromWishlist(id, variantId, Number(window.customerId))
					el.classList.remove("added")
				} else {
					await addItemToWishlist(id, variantId, Number(window.customerId))
					el.classList.add("added")
				}
			}
			if (upsellProd) upsellProd.style.opacity = 1
		})
	})
	addEventPdpButton()
	initNewPdpEvents()

	addEventWishlistBtn()
	getWishlistItems()

	setTimeout(() => {
		loadmoreCleanup()
	}, 50)

	setupStickyCartTotal()
}


// Expose binder and normalized helpers for the add-on controller
window.bt = init; // (re)attach all cart listeners

window.CartHelpers = {
  // (variantId, flag=true, qty=1)
  add: (id, flag = true, qty = 1) => addItem(Number(id), flag, qty),
  // (variantId, qty) -> your removeItem is actually "set qty"
  change: (id, qty = 0) => removeItem(Number(id), true, Number(qty))
};

// ── Analytics helpers ──

const _updateCartAttributes = async (attrs) => {
  try {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    })
  } catch (_) {}
}

const _fireUpsellEvent = (eventName, data) => {
  if (window.Shopify?.analytics?.publish) {
    window.Shopify.analytics.publish(eventName, data)
  }
}

const _fireCtfAddToCartEvent = (variantId, handle, card) => {
  const nameEl    = card?.querySelector('.ctf-card__name')
  const priceEl   = card?.querySelector('.ctf-card__price--sale') || card?.querySelector('.ctf-card__price:not(.ctf-card__price--original)')
  const name      = nameEl?.textContent?.trim() || handle
  const rawPrice  = priceEl?.textContent?.trim() || '0'
  const cleaned   = rawPrice.replace(/[^\d.,]/g, '')
  const lastComma = cleaned.lastIndexOf(',')
  const lastDot   = cleaned.lastIndexOf('.')
  const price     = lastComma > lastDot
    ? parseFloat(cleaned.replace(/\./g, '').replace(',', '.')) || 0
    : parseFloat(cleaned.replace(/,/g, '')) || 0
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ ecommerce: null })
  window.dataLayer.push({
    event: 'add_to_cart',
    ecommerce: {
      currency: window.Shopify?.currency?.active || '',
      value: price,
      items: [{
        item_id: String(variantId),
        item_name: name,
        item_list_name: 'Complete the Fit',
        price: price,
        quantity: 1
      }]
    }
  })
}

const _trackUpsellImpression = () => {
  const strip = document.querySelector('.ctf-strip')
  if (!strip) return
  const handles = Array.from(strip.querySelectorAll('[data-ctf-add]'))
    .map(btn => btn.getAttribute('data-handle'))
    .filter(Boolean)
    .join(',')
  if (!handles) return
  _updateCartAttributes({ _upsell_products_shown: handles })
  _fireUpsellEvent('cart_upsell_impression', {
    products: handles.split(','),
    market: window.cartDrawer?.market || '',
    source: 'cart_drawer'
  })
}

// Returns the colour fetched from the product's custom.colour metafield.
// p._colour is populated by a secondary /products/handle.json fetch in loadCtfFallbacks.
const _ctfColorFromProduct = p => p._colour || ''

// ── Complete the Fit — automatic recommendations ──
// Fires on every cart load. Fetches 2 API recommendation cards and reorders
// all cards into interleaved pattern: MPU[0], Meta[0], API[0], MPU[1], Meta[1], API[1].
const loadCtfFallbacks = async () => {
	const strip = document.querySelector('.ctf-strip[data-ctf-fallbacks]')
	if (!strip) return

	const fallbackIds = (strip.getAttribute('data-ctf-fallbacks') || '')
		.split(',')
		.map(s => s.trim())
		.filter(Boolean)
	if (!fallbackIds.length) return

	const scroll = strip.querySelector('[data-ctf-scroll]')
	if (!scroll) return

	const existingHandles = new Set(
		Array.from(scroll.querySelectorAll('[data-ctf-add]')).map(btn => btn.getAttribute('data-handle'))
	)
	const cartIds = new Set(
		Array.from(document.querySelectorAll('.cart_drawer--item[data-id]'))
			.map(el => el.getAttribute('data-id'))
	)

	const allProducts = []
	const seenIds = new Set()

	await Promise.all(fallbackIds.map(async productId => {
		try {
			const res = await fetch(`/recommendations/products.json?product_id=${productId}&limit=6&intent=related`)
			const data = await res.json()
			const products = data?.products || []
			products.forEach(p => {
				if (!seenIds.has(p.id) && !cartIds.has(String(p.id)) && !existingHandles.has(p.handle)) {
					seenIds.add(p.id)
					allProducts.push(p)
				}
			})
		} catch (_) {}
	}))

	// Always fetch 2 API recommendation cards
	const recommended = allProducts.slice(0, 2)

	// Fetch colour metafield for each recommended product via the ctf-colour template
	await Promise.all(recommended.map(async p => {
		try {
			const res = await fetch(`/products/${p.handle}?view=ctf-colour`)
			const text = await res.text()
			p._colour = JSON.parse(text) || ''
		} catch (_) {
			p._colour = ''
		}
	}))

	const sym = window.cartDrawer?.currencySymbol || ''
	const makeCardEl = p => {
		const isSingle    = p.variants?.length === 1
		const firstVar    = p.variants?.[0]
		const variantAttr = isSingle && firstVar ? `data-variant-id="${firstVar.id}"` : ''
		const compareAt   = p.compare_at_price
		const isOnSale    = compareAt && compareAt > p.price
		const discountPct = isOnSale ? Math.round((1 - p.price / compareAt) * 100) : 0
		const priceHtml   = isOnSale
			? `<div class="ctf-card__price-wrap">
				<div class="ctf-card__price-row">
					<span class="ctf-card__price ctf-card__price--original">${sym}${(compareAt / 100).toFixed(2)}</span>
					<span class="ctf-card__badge">-${discountPct}%</span>
				</div>
				<span class="ctf-card__price ctf-card__price--sale">${sym}${(p.price / 100).toFixed(2)}</span>
			</div>`
			: `<span class="ctf-card__price">${sym}${(p.price / 100).toFixed(2)}</span>`
		const imgSrc = p.featured_image
			? p.featured_image.replace(/(\.\w+)(\?.*)?$/, '_220x220$1')
			: ''
		const imgHtml = imgSrc
			? `<img class="ctf-card__img" src="${imgSrc}" alt="${p.title}" loading="lazy">`
			: `<span class="ctf-card__img-placeholder"></span>`
		const sizeBtns = !isSingle
			? (p.variants || []).map(v =>
				`<button class="ctf-card__size-btn" data-ctf-size data-variant-id="${v.id}" data-handle="${p.handle}" ${v.available ? '' : 'disabled'} aria-label="${v.title}">${v.title}</button>`
			).join('')
			: ''
		const sizesEl = !isSingle
			? `<div class="ctf-card__sizes" data-ctf-sizes><span class="ctf-card__sizes-label">Size</span>${sizeBtns}</div>`
			: ''
		const colorTitle = _ctfColorFromProduct(p)
		const colorHtml = colorTitle ? `<span class="ctf-card__meta">${colorTitle}</span>` : ''
		const div = document.createElement('div')
		div.innerHTML = `
		<div class="ctf-card" role="group" aria-label="${p.title}" data-ctf-source="api">
			<a class="ctf-card__img-link" href="/products/${p.handle}">${imgHtml}</a>
			<div class="ctf-card__info">
				<a class="ctf-card__name" href="/products/${p.handle}">${p.title}</a>
				${colorHtml}
				${priceHtml}
			</div>
			<div class="ctf-card__actions">
				<button class="ctf-card__add" data-ctf-add data-handle="${p.handle}" ${variantAttr} aria-label="Add ${p.title} to cart">
					<span class="ctf-card__add-label">+ ADD</span>
					<span class="ctf-card__add-spinner" aria-hidden="true"></span>
				</button>
			</div>
			${sizesEl}
		</div>`
		return div.firstElementChild
	}

	// Build interleaved order: MPU[0], Meta[0], API[0], MPU[1], Meta[1], API[1]
	const mpuCards  = Array.from(scroll.querySelectorAll('.ctf-card[data-ctf-source="mpu"]'))
	const metaCards = Array.from(scroll.querySelectorAll('.ctf-card[data-ctf-source="meta"]'))
	const apiCards  = recommended.map(p => makeCardEl(p))
	const ordered   = []
	for (let i = 0; i < 2; i++) {
		if (mpuCards[i])  ordered.push(mpuCards[i])
		if (metaCards[i]) ordered.push(metaCards[i])
		if (apiCards[i])  ordered.push(apiCards[i])
	}
	if (ordered.length) {
		scroll.innerHTML = ''
		ordered.forEach(card => scroll.appendChild(card))
	}

	const total = scroll.querySelectorAll('.ctf-card').length
	strip.dataset.ctfTotal = total
	const counter = strip.querySelector('.ctf-strip__counter')
	if (counter) counter.textContent = `1 / ${total}`
	const prevBtn = strip.querySelector('[data-ctf-prev]')
	const nextBtn = strip.querySelector('[data-ctf-next]')
	if (prevBtn) prevBtn.disabled = true
	if (nextBtn) nextBtn.disabled = total <= 1

	_trackUpsellImpression()
}

// ── Complete the Fit — helpers ──

const _ctfSetLoading = (btn, flag) => {
	btn.classList.toggle('is-loading', flag)
	btn.disabled = flag
}

const _ctfSetSuccess = btn => {
	btn.classList.remove('is-loading')
	btn.classList.add('is-success')
	btn.disabled = true
	setTimeout(() => {
		btn.classList.remove('is-success')
		btn.disabled = false
	}, 1800)
}

// ── Complete the Fit — global event delegation ──
// Handles nav arrows and "+ ADD" for per-item CTF strips.
// Uses delegation so it works after every cart reload without re-binding.
const _ctfNav = async e => {
	const prevBtn = e.target.closest('[data-ctf-prev]')
	const nextBtn = e.target.closest('[data-ctf-next]')
	const addBtn  = e.target.closest('[data-ctf-add]')

	// ── Card image / name click analytics ──
	const cardLink = e.target.closest('.ctf-card__img-link, .ctf-card__name')
	if (cardLink) {
		const card = cardLink.closest('.ctf-card')
		const handle = card?.querySelector('[data-ctf-add]')?.getAttribute('data-handle') || ''
		const position = Array.from(document.querySelectorAll('.ctf-card')).indexOf(card)
		_fireUpsellEvent('cart_upsell_click', {
			product_handle: handle,
			position: position + 1
		})
	}

	// ── Navigation arrows ──
	if (prevBtn || nextBtn) {
		const strip  = (prevBtn || nextBtn).closest('.ctf-strip')
		const scroll = strip?.querySelector('[data-ctf-scroll]')
		if (!scroll) return

		const total   = Number(strip.dataset.ctfTotal) || 1
		let   current = Number(strip.dataset.ctfIndex) || 0

		if (nextBtn) current = Math.min(current + 1, total - 1)
		if (prevBtn) current = Math.max(current - 1, 0)

		strip.dataset.ctfIndex = current
		const cardW = scroll.querySelector('.ctf-card')?.offsetWidth || scroll.offsetWidth
		scroll.scrollTo({ left: cardW * current, behavior: 'smooth' })

		const counter = strip.querySelector('.ctf-strip__counter')
		if (counter) counter.textContent = `${current + 1} / ${total}`

		strip.querySelector('[data-ctf-prev]').disabled = current === 0
		strip.querySelector('[data-ctf-next]').disabled = current === total - 1
	}

	// ── Size button click — add to cart immediately ──
	const sizeBtn = e.target.closest('[data-ctf-size]')
	if (sizeBtn && !sizeBtn.disabled) {
		e.preventDefault()
		const variantId = sizeBtn.getAttribute('data-variant-id')
		const handle    = sizeBtn.getAttribute('data-handle') || ''
		const card      = sizeBtn.closest('.ctf-card')
		const sizesEl   = card?.querySelector('[data-ctf-sizes]')
		const addBtn2   = card?.querySelector('[data-ctf-add]')
		if (!variantId) return

		sizeBtn.disabled = true
		try {
			await window.CartHelpers.add(Number(variantId))
			if (sizesEl) sizesEl.classList.remove('is-open')
			if (addBtn2) {
				addBtn2.classList.remove('is-picking')
				addBtn2.querySelector('.ctf-card__add-label').textContent = '+ ADD'
				_ctfSetSuccess(addBtn2)
			}
			const existing = sessionStorage.getItem('_upsell_added') || ''
			const updated  = existing ? existing + ',' + handle : handle
			sessionStorage.setItem('_upsell_added', updated)
			_updateCartAttributes({ _upsell_triggered: 'true', _upsell_products_added: updated })
			_fireUpsellEvent('cart_upsell_add', { product_handle: handle, variant_id: variantId, market: window.cartDrawer?.market || '' })
			_fireCtfAddToCartEvent(variantId, handle, card)
		} catch (_) {
			sizeBtn.disabled = false
		}
		return
	}

	// ── + ADD button ──
	if (addBtn && !addBtn.disabled) {
		e.preventDefault()
		const handle    = addBtn.getAttribute('data-handle')
		const variantId = addBtn.getAttribute('data-variant-id')

		if (!handle) return

		if (variantId) {
			// Single-variant: add directly, show success inline
			_ctfSetLoading(addBtn, true)
			try {
				await window.CartHelpers.add(Number(variantId))
				_ctfSetSuccess(addBtn)
				const existing = sessionStorage.getItem('_upsell_added') || ''
				const updated = existing ? existing + ',' + handle : handle
				sessionStorage.setItem('_upsell_added', updated)
				_updateCartAttributes({ _upsell_triggered: 'true', _upsell_products_added: updated })
				_fireUpsellEvent('cart_upsell_add', { product_handle: handle, variant_id: variantId, market: window.cartDrawer?.market || '' })
				_fireCtfAddToCartEvent(variantId, handle, addBtn.closest('.ctf-card'))
			} catch (_) {
				_ctfSetLoading(addBtn, false)
			}
		} else {
			// Multi-variant: toggle inline size picker
			const card    = addBtn.closest('.ctf-card')
			const sizesEl = card?.querySelector('[data-ctf-sizes]')
			if (!sizesEl) return

			const isOpen = sizesEl.classList.contains('is-open')
			if (isOpen) {
				sizesEl.classList.remove('is-open')
				addBtn.classList.remove('is-picking')
				addBtn.querySelector('.ctf-card__add-label').textContent = '+ ADD'
			} else {
				sizesEl.classList.add('is-open')
				addBtn.classList.add('is-picking')
				addBtn.querySelector('.ctf-card__add-label').textContent = '✕'
			}
		}
	}
}

const _ctfSyncOnScroll = e => {
	const scroll = e.currentTarget
	const strip  = scroll.closest('.ctf-strip')
	if (!strip) return
	const cardW   = scroll.querySelector('.ctf-card')?.offsetWidth || scroll.offsetWidth
	if (!cardW) return
	const current = Math.round(scroll.scrollLeft / cardW)
	const total   = Number(strip.dataset.ctfTotal) || 1
	strip.dataset.ctfIndex = current
	const counter = strip.querySelector('.ctf-strip__counter')
	if (counter) counter.textContent = `${current + 1} / ${total}`
	const prevBtn = strip.querySelector('[data-ctf-prev]')
	const nextBtn = strip.querySelector('[data-ctf-next]')
	if (prevBtn) prevBtn.disabled = current === 0
	if (nextBtn) nextBtn.disabled = current === total - 1
}

const initCompleteTheFit = () => {
	document.removeEventListener('click', _ctfNav)
	document.addEventListener('click', _ctfNav)
	document.querySelectorAll('[data-ctf-scroll]').forEach(scroll => {
		scroll.removeEventListener('scroll', _ctfSyncOnScroll)
		scroll.addEventListener('scroll', _ctfSyncOnScroll, { passive: true })
	})
}

renderUpsell()

// Ensure _upsell_market is set on every page load, not just when the cart is opened.
// This covers customers who go directly to checkout without opening the cart drawer.
if (!sessionStorage.getItem('_upsell_market_set')) {
	sessionStorage.setItem('_upsell_market_set', '1')
	_updateCartAttributes({ _upsell_market: window.cartDrawer?.market || '' })
}
